import { MY_PROFILE, ACCOUNT, NOTIFICATIONS } from 'common/endpoints'

const errorHandler = ({ url, status, data }, error) => {
  if (url == MY_PROFILE && status == 401) {
    return console.warn('Not fully logged in')
  }
  if (url == NOTIFICATIONS.GET && status == 401) {
    return console.warn('Session expired')
  }
  if (url == ACCOUNT.REGISTRATION_CONFIRMATION && /401|204/.test(status)) {
    return console.warn(`Registration ${status == 204 ? 'already confirmed' : 'info already known'}`)
  }
  if (url == ACCOUNT.RESEND_CONFIRMATION_EMAIL && status == 422) {
    return console.warn('Trying to resend email in < 5 mins')
  }
  if (url.match(/\/chat$/) && /400|404/.test(status)) {
    return console.warn('CCP - Known error response', { url, status, data })
  }
  throw error
}

export default errorHandler
